var _path, _g, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogooo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2000,
    height: 474,
    viewBox: "0 0 2000 474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.2121212121212466,-0.10901836653954433)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 396 94",
    "data-background-color": "#581381",
    preserveAspectRatio: "xMidYMid meet",
    height: 474,
    width: 2000,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tight-bounds",
    transform: "matrix(1,0,0,1,0.2400000000000091,0.02161967606480175)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52 93.95676064787042",
    height: 93.95676064787042,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52000000000004 93.95676064787044",
    height: 93.95676064787042,
    width: 395.52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52000000000004 93.95676064787044",
    height: 93.95676064787044,
    width: 395.52000000000004,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "textblocktransform"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52000000000004 93.95676064787044",
    height: 93.95676064787044,
    width: 395.52000000000004,
    id: "textblock",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 395.52000000000004 93.95676064787044",
    height: 93.95676064787044,
    width: 395.52000000000004,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52000000000004,
    viewBox: "1 -38.9 166.69 39.6",
    height: 93.95676064787044,
    "data-palette-color": "#f5a1e8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.15-38.9L56.15-30.7 53.65-30.7 53.65-8.2 56.15-8.2 56.15 0 37.25 0 37.25-8.2 39.65-8.2 39.65-25.7 31.15 0 23.75 0 15-25.45 15-8.2 17.4-8.2 17.4 0 1 0 1-8.2 3.5-8.2 3.5-30.7 1-30.7 1-38.9 23.9-38.9 29.1-23.3 34.1-38.9 56.15-38.9ZM72.95 0.7Q65.85 0.7 61.85-3.03 57.85-6.75 57.85-13.9L57.85-13.9Q57.85-21.05 61.85-24.78 65.85-28.5 72.95-28.5L72.95-28.5Q80.15-28.5 84.1-24.73 88.05-20.95 88.05-13.9L88.05-13.9Q88.05-6.75 84.05-3.03 80.05 0.7 72.95 0.7L72.95 0.7ZM72.95-8.2Q74.4-8.2 75.12-8.97 75.85-9.75 75.85-11.4L75.85-11.4 75.85-16.4Q75.85-18.05 75.12-18.82 74.4-19.6 72.95-19.6L72.95-19.6Q71.5-19.6 70.77-18.82 70.05-18.05 70.05-16.4L70.05-16.4 70.05-11.4Q70.05-9.75 70.77-8.97 71.5-8.2 72.95-8.2L72.95-8.2ZM112.55 0L97.65 0 91.34-19.6 89.25-19.6 89.25-27.8 104.7-27.8 104.7-19.6 102.59-19.6 105.25-9.7 105.75-9.7 108.4-19.6 106.3-19.6 106.3-27.8 120.8-27.8 120.8-19.6 118.7-19.6 112.55 0ZM134.79-30.55L124.59-30.55 124.59-38.9 134.79-38.9 134.79-30.55ZM138.09 0L122.19 0 122.19-8.2 124.39-8.2 124.39-19.6 122.19-19.6 122.19-27.8 135.89-27.8 135.89-8.2 138.09-8.2 138.09 0ZM154.39 0.7Q147.29 0.7 143.29-3.03 139.29-6.75 139.29-13.9L139.29-13.9Q139.29-21.05 143.29-24.78 147.29-28.5 154.39-28.5L154.39-28.5Q161.44-28.5 164.57-24.83 167.69-21.15 167.69-15.7L167.69-15.7 167.69-12.1 151.49-12.1 151.49-11.8Q151.49-9.95 152.59-9.08 153.69-8.2 156.24-8.2L156.24-8.2Q159.29-8.2 162.04-8.65 164.79-9.1 166.84-9.8L166.84-9.8 166.84-1.8Q165.09-0.85 161.72-0.08 158.34 0.7 154.39 0.7L154.39 0.7ZM151.49-17.6L157.29-17.6 157.29-18.2Q157.29-19.9 156.57-20.65 155.84-21.4 154.39-21.4L154.39-21.4Q152.94-21.4 152.22-20.63 151.49-19.85 151.49-18.2L151.49-18.2 151.49-17.6Z",
    opacity: 1,
    transform: "matrix(1,0,0,1,0,0)",
    fill: "#f5a1e8",
    className: "wordmark-text-0",
    "data-fill-palette-color": "primary",
    id: "text-0"
  })))))))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 395.52,
    height: 93.95676064787042,
    fill: "none",
    stroke: "none",
    visibility: "hidden"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogooo);
export default __webpack_public_path__ + "static/media/logooo.cedec73cb60965d4bee285d7cbbf93b0.svg";
export { ForwardRef as ReactComponent };